/**
 * SYNCED FROM SERVER — do not edit by hand.
 *
 * Source: `server/src/api/<domain>/<domain>.contract.ts` (or the
 * shared bases under `server/src/api/common/contracts/`).
 *
 * Regenerate: `cd api-client && bun run sync:contracts`.
 *
 * The server is the source of truth for contract definitions. This
 * file exists so the web SPA can import zod schemas + oRPC contract
 * types from `@event-manager/api-client/contracts/<domain>.contract`
 * without reaching into the server workspace.
 */

import { z } from "zod";
import { EventStatusSlugSchema } from "./domain-schemas/event-status/event-status-definition.schema";

export type { EventStatusDefinition } from "./domain-schemas/event-status/event-status-definition.schema";
export {
	EventStatusDefinitionSchema,
	EventStatusSlugSchema,
} from "./domain-schemas/event-status/event-status-definition.schema";

export const EventStatusUpsertInputSchema = z
	.object({
		id: z.string().optional(),
		slug: EventStatusSlugSchema.optional(),
		label: z.string().min(1).max(80),
		color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
		position: z.number().int().min(0).optional(),
	})
	.strict();

export type EventStatusUpsertInput = z.infer<
	typeof EventStatusUpsertInputSchema
>;
